export default "__VITE_ASSET__DEvk57N8__"